import * as React from 'react';
import { CancellationReasons } from '../../../../../../../../services/mta/models';

interface IAMTCancelReasonTextProps {
  reason: string;
  customerFirstName: string;
  discount: any;
  isRenewal?: boolean;
  isInCoolingOff?: boolean;
}

export const AMTCancelReasonText = ({
                                      reason,
                                      customerFirstName,
                                      discount,
                                      isRenewal = false,
                                      isInCoolingOff = false,
                                    }: IAMTCancelReasonTextProps) => {

  const dc = discount?.selected?.discount || 0;
  const dcPrevious = discount?.previousDiscount || 0;
  const discountValue = dc - dcPrevious > 0 ? dc - dcPrevious : null;
  const showDiscountText = isRenewal ? !!discountValue : isInCoolingOff && discountValue

  switch (reason) {
    case CancellationReasons.NOT_TRAVELLING_SOON:
      return (
        <>
          {showDiscountText && (
            <>
              <p>
                {customerFirstName}, we understand that you aren't travelling soon which is why we are delighted to
                be able to offer you <b><u>a {discountValue}% discount on your {isRenewal ? 'renewal' : 'cover'}</u></b>,
                whilst you plan your next trip!
              </p>
              <p>
                By remaining on cover, your trips are instantly protected from unexpected cancellations the moment
                you book them.*
              </p>
            </>
          )}

          {!showDiscountText && (
            <div>
              {customerFirstName}, we understand that you aren’t travelling soon but by remaining on cover, <b><u>your
              trips are instantly protected from unexpected cancellations the moment you book them.*</u></b>
            </div>
          )}

          <div style={{ textAlign: 'right', marginTop: '35px' }}>
            <p style={{ fontStyle: 'italic', color: 'grey', fontSize: '12px' }}>* within cover limits</p>
          </div>
        </>
      )
    case CancellationReasons.POOR_SERVICE:
      return (
        <>
          <p><b>{customerFirstName}, we're truly sorry that you've had a bad experience with us. If there is
            anything we can do to fix this, don't hesitate to contact us.</b></p>
          <p>We value all our customers and always aim for perfect service. That’s why our platinum tier is rated 5
            stars by Defaqto.</p>
          {showDiscountText && (
            <p>We would love to offer you <b><u>a {discountValue}% discount on your cover.</u></b></p>
          )}
        </>
      )
    case CancellationReasons.TOO_EXPENSIVE:
    case CancellationReasons.COVER_NOT_SUITABLE:
    case CancellationReasons.OTHER:
      return (
        <>
          {showDiscountText && (
            <>
              <p>{customerFirstName}, did you know that you can change your policy to meet your needs?</p>
              <p>
                You can change the number of people insured, your level of cover and the region you are travelling to by
                following the link below.
              </p>
              <p>To say thank you for continuing to be insured with us, we are delighted to offer
                you <b><u>a {discountValue}% discount on your cover!</u></b></p>
            </>
          )}
          {!showDiscountText && (
            <>
              <p>{customerFirstName}, did you know that you can change your policy to meet your needs? You can change
                the number of people insured, your level of cover and the region you are travelling to by following the
                link below.</p>
            </>
          )}
        </>
      )
  }

  return null;
}
